import { render, staticRenderFns } from "./politicalStatus.vue?vue&type=template&id=434c4408&"
import script from "./politicalStatus.vue?vue&type=script&lang=js&"
export * from "./politicalStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports